import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { QuoteIcon, StarIcon } from './icons/GoldIcons';
const ease = [0.23, 1, 0.32, 1] as const;
function Stars({
  label
}: {
  label: string;
}) {
  return <div className="flex gap-1 text-gold-bright" aria-label={label} data-id="element-360" data-mp="3b1cjj9hq2yim">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5" data-id="element-361" data-mp="36z95qe7kzhu6" />)}
    </div>;
}
export function Testimonials() {
  const {
    t
  } = useLanguage();
  return <section id="resenas" className="w-full bg-ink-900 py-24 sm:py-32" data-id="element-362" data-mp="31yl7b7h0vypx">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-363" data-mp="2x1utyrwlrh87">
        <SectionHeading eyebrow={t.testimonials.eyebrow} title={t.testimonials.title} data-id="element-364" data-mp="2s1qact0ee6dr" />

        <div className="mt-16 grid grid-cols-1 gap-8 lg:grid-cols-[1.15fr_1fr]" data-id="element-365" data-mp="2s4319vo4vr2y">
          <motion.figure initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          ease
        }} className="flex flex-col justify-between rounded-3xl border border-gold-soft/30 bg-[radial-gradient(ellipse_at_top_left,rgba(212,168,87,0.15),transparent_65%)] p-9 sm:p-12" data-id="element-366" data-mp="v8nad69yidgi">
            <div data-id="element-367" data-mp="c625ghntxpp4">
              <QuoteIcon className="h-9 w-9 text-gold-glow/70" data-id="element-368" data-mp="c7n0e8e23ani" />
              <blockquote className="mt-7 font-display text-2xl leading-snug text-neutral-100 sm:text-3xl" data-id="element-369" data-mp="zvwfkrgrl05o">
                “{t.testimonials.featured.quote}”
              </blockquote>
            </div>
            <figcaption className="mt-10" data-id="element-370" data-mp="q7666ujea9wn">
              <Stars label={t.a11y.fiveStars} data-id="element-371" data-mp="q6cv5hdeky8p" />
              <p className="mt-3 text-[12px] uppercase tracking-[0.24em] text-gold-muted" data-id="element-372" data-mp="v57mx8tclx4y">
                {t.testimonials.featured.author}
              </p>
            </figcaption>
          </motion.figure>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-1" data-id="element-373" data-mp="1nma8slb3551u">
            {t.testimonials.items.map((item, index) => <motion.figure key={item.author} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.35,
            ease,
            delay: index * 0.05
          }} className="flex h-full flex-col border-l border-gold-deep/35 pl-6" data-id="element-374" data-mp="1xgpn1kf636ca" data-mpi={index}>
                <Stars label={t.a11y.fiveStars} data-id="element-375" data-mp="1ekzh5m445pt4" />
                <blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-neutral-300" data-id="element-376" data-mp="19rdemmrnz2b1">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-auto pt-4 text-[11px] uppercase tracking-[0.22em] text-gold-muted" data-id="element-377" data-mp="10rqc1xn77qge">
                  {item.author}
                  {item.meta ? <span className="text-neutral-600" data-id="element-378" data-mp="vrc4shtf8kjf"> · {item.meta}</span> : null}
                </figcaption>
              </motion.figure>)}
          </div>
        </div>
      </div>
    </section>;
}